export const getChartDataByUsingInterval = ({
  list,
  finish,
  intervalCount,
  start,
}: {
  list: number[];
  start: number;
  finish: number;
  intervalCount: number;
}) => {
  const interval = finish - start;
  const sectionInterval = interval / intervalCount;

  const getValueFromList = (value: number) => {
    return (value - ((value - start) % sectionInterval)).toFixed(2);
  };

  const amountByValue =
    list.reduce<{ [K: string]: number }>((acc, value) => {
      const valueFromList = getValueFromList(value);
      const updatedValue = acc[valueFromList];
      return {
        ...acc,
        [valueFromList]: updatedValue ? updatedValue + 1 : 1,
      };
    }, {}) || [];

  const averageValue = list.reduce((acc, num) => acc + num, 0) / list.length;

  const sortedByValueList = Object.entries(amountByValue).sort((a, b) => {
    return Number(a[0]) - Number(b[0]);
  });

  const chartData = sortedByValueList.map((el) => ({
    value: el[0],
    amount: el[1],
  }));

  const middleLine = getValueFromList(averageValue);

  return { chartData, middleLine };
};
